export default __webpack_public_path__ + "static/media/icon-ic-faceobook.8e7a002a.svg";